import { createAction, props } from '@ngrx/store';

export const fundPreferenceMissingPerms = createAction(
	'[Data Loading] Fund Preference Missing Perms',
	props<{
		payload: {
			store: string;
		};
	}>()
);

export const fundPreferenceChildMissingPerms = createAction(
	'[Data Loading] Fund Preference Child Missing Perms',
	props<{
		payload: {
			store: string;
			childrenMissingWudPerms: Set<string>;
			fundPreferences: any;
		};
	}>()
);
